import { TApplicationState } from '../../types/redux';
import { selectMortgagePromos } from './selectMortgagePromos';

export const selectHasMortgagePromos = (state: TApplicationState): boolean => {
  const promos = selectMortgagePromos(state);

  return promos.length > 0;
};
